import { SessionContextProps } from "../../../Context/SessionContext";
import { UserContextProps } from "../../../Context/UserContext";
import NoteTagConfigs from "../Types/NoteTagConfigs";
import { SeriesNoteTagsBuilder } from "../Types/NoteTagsConfiguration";

/** The session and user context properties provided to a note tag template callback. */
export type ContextNoteTagTemplateProps = Pick<
  SessionContextProps,
  "medicalConclusions" | "appointment" | "customer" | "ignoreNonCan" | "lead" | "selectedCustomer" | "leadDisqualifiers"
> &
  Pick<UserContextProps, "user">;

/** The configuration for how note tags are rendered for customer notes. */
const CustomerNoteTagsConfiguration = new SeriesNoteTagsBuilder<ContextNoteTagTemplateProps>([
  NoteTagConfigs.noLabelAppointmentServiceSubCategory,
  NoteTagConfigs.noLabelPatientAmbassadorInitials,
  NoteTagConfigs.noLabelLeadContactType,
  NoteTagConfigs.noLabelServiceType,
  NoteTagConfigs.interestsIfAppointmentAndQiChanged,
  NoteTagConfigs.customerQualificationInfoIfAppointmentAndQiChanged,
  NoteTagConfigs.centerAndDistanceIfChanged,
  NoteTagConfigs.ignorableNonCanStatus,
  NoteTagConfigs.customerDiabetic,
  NoteTagConfigs.customerRadiationArea,
  NoteTagConfigs.defibrillatorEvalRequired
]);

export default CustomerNoteTagsConfiguration;
